import { useEffect, useState, useRef } from 'react';
import {
  closeWindow,
  go2LoginIfNot,
  webviewOpen,
  reportUserBehavior
} from '../../utils/common';
import { getChargeReview } from '../../api/yearly-report';
import Confirm from '../../components/confirm';
import FullLoading from '../../components/full-loading';
import html2canvas from 'html2canvas';
// import domtoimage from 'dom-to-image';
import bridge from '@xpeng/js-bridge';
// import postStyle from './components/share-model/index.module.css';
import postStyle from './app.module.css';

// import Toast from '@xpeng/rc-toast';
// import Toast from '@xpeng/rc-toast';

export function useConfig() {
  const [loading, setLoading] = useState(false);
  const [uid, setAuthForMX] = useState<any>(null);
  const [yearlyData, setYearlyData] = useState<any>(null);
  const [posterData, setPosterData] = useState<any>(null);
  const [interTips, setInterTips] = useState('登录验证...');
  const [isXpOwner, setXpOwnerFlag] = useState(true);
  const [showPopupModel, setPopupModel] = useState(false);
  const [popupModelType, setPopupModelType] = useState(1);
  const [popuModelTitle, setPopuModelTitle] = useState('');
  const [popuModelContent, setPopuModelContent] = useState('');
  const [copyrightContent, setCopyrightContent] = useState('');
  const [copyrightFlag, setCopyrightFlag] = useState(false);
  const [closeWindowFlag, setCloseWindowFlag] = useState(true);
  const [confirmText, setConfirmText] = useState('');
  const [cancelText, setCancelText] = useState('');
  const [captureImgSrc, setcaptureImgSrc] = useState('');
  const [shareModel, setShareModel] = useState(false);
  const [swiperController, setSwiperFun] = useState<any>(null);
  const [yearlyReportFlag, setYearlyReportFlag] = useState(false);
  const [agreedFlag, setAgreedFlag] = useState(false);
  const [agreedModdeFlag, agreedModdeStatus] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [audioFlag, setAudioFlag] = useState(true);
  const [nextStatus, setNextStatusFun] = useState(true);
  const [btnSeconds, setBtnSeconds] = useState(0);
  const [whiteIconFlag, setWhiteIconFlag] = useState(false);

  const compare = property => {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    };
  };

  useEffect(() => {
    if (loading) {
      FullLoading.show({
        text: '加载中'
      });
    } else {
      FullLoading.hide();
    }
  }, [loading]);

  useEffect(() => {
    // setLoading(true);
    go2LoginIfNot()
      .then(loginData => {
        if (!loginData) {
          Confirm.open('请先登录', {
            type: 2,
            confirmText: '确定',
            header: '',
            confirmCbk: (destroy): void => {
              destroy();
              // 关闭h5
              closeWindow();
            }
          });
        } else {
          // 已登录
          const { uid } = loginData;
          console.log(uid);
          setAuthForMX(parseInt(uid));
        }
      })
      .catch(e => {
        console.log('页面出错', e.message);
        setLoading(false);
        closeWindow();
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // 发起请求，身份鉴权
    if (uid) {
      setInterTips('正在加载, 请稍等...');
      setLoading(true);
      getChargeReview({ uid })
        .then(data => {
          setLoading(false);
          console.log(data);
          // 进入年度报告页面首页
          reportUserBehavior({
            appid: 'N005',
            so: 'N005001',
            ch: '4_0+',
            ut: '',
            mcode: 'summary_page_init_uid_' + uid,
            pa: 'summary_page_init_uid_' + uid
          });
          if (data.isOverDate) {
            // 活动结束处理
            setXpOwnerFlag(false);
            setPopupModel(true);
            setPopupModelType(1);
            setPopuModelTitle('活动已结束');
            setPopuModelContent('让我们来年再见~');
            setCopyrightFlag(false);
            setCancelText('确定');
          } else if (data.content.length <= 0 || !data.content) {
            setXpOwnerFlag(false);
            setPopupModel(true);
            setPopupModelType(2);
            setPopuModelTitle('您还不是小鹏车主');
            setPopuModelContent('小鹏汽车邀您试驾，开启小鹏超充之旅');
            setCopyrightFlag(false);
            setConfirmText('预约试驾');
            setCancelText('关闭');
          } else {
            // console.log(data.content.sort(compare('order')));

            // 播放音乐
            // setTimeout原因是为了解决个别安卓手机，第一次进入页面，android手机无声音问题
            if (audioRef && audioRef.current && audioFlag) {
              console.log('音乐播放');
              // console.log(audioRef);
              // 增加回调来获取 onPlay 和 onPasue 的状态，记录一个 playing 的 flag，播放中，则调动 pause()
              // 参考源代码中增加 event 的方式 https://github.com/justinmc/react-audio-player/blob/master/src/index.tsx
              audioRef.current.src =
                'https://s.xiaopeng.com/xp-charge/charge/report/year_report_bgm.mp3';

              audioRef.current.play().catch(e => {
                console.log(`error: ${e}`);

                setTimeout(() => {
                  setAudioFlag(false);
                  setPopupModel(true);
                  setPopupModelType(1);
                  setPopuModelTitle('温馨提示');
                  setPopuModelContent('打开背景音乐效果更佳哦~');
                  setCopyrightFlag(false);
                  setCancelText('知道了');
                  setCloseWindowFlag(false);
                  // if (audioRef && audioRef.current) {
                  //   audioRef.current.pause();
                  // }
                  // setTimeout(() => {
                  //   setAudioFlag(true);
                  //   if (audioRef && audioRef.current) {
                  //     audioRef.current.play();
                  //   }
                  // }, 2000);
                }, 4000);
              });
            }

            const dataSource = data.content
              .sort(compare('order'))
              .filter(item => {
                return !!item.status && item.status !== 0;
              });
            setYearlyData(dataSource);
            // 筛选海报数据
            let filterId = ['p10'];
            let posterDataResult = data.content.filter(a => {
              return filterId.some(f => f === a.page);
            });
            setPosterData(posterDataResult);
            // console.log(posterData);
            let agreedStorage = localStorage.getItem(uid + '_' + 'hasAgreed');
            // console.log('存储的data');
            // console.log(uid + '_' + 'hasAgreed' + agreedStorage);
            if (agreedStorage) {
              setAgreedFlag(true);
            }
          }
        })
        .catch(e => {
          console.log('页面出错', e);
          setXpOwnerFlag(false);
          setPopupModel(true);
          setPopupModelType(1);
          setPopuModelTitle('页面出错');
          setPopuModelContent('服务器开小差了，请再试一次');
          setCopyrightFlag(false);
          setCancelText('知道了');
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [uid]);

  const showInstructionModel = rule => {
    console.log(rule);
    setPopupModel(true);
    setPopupModelType(1);
    setPopuModelTitle('规则说明');
    setPopuModelContent(rule);
    setCancelText('确定');
    setCopyrightFlag(false);
    setCloseWindowFlag(false);
  };

  const closeShareModel = () => {
    console.log('关闭分享弹窗');
    setShareModel(false);
  };

  const cancelCb = () => {
    if (!closeWindowFlag) {
      setPopupModel(false);
    } else {
      closeWindow();
    }
  };

  const confirmFun = () => {
    if (!isXpOwner) {
      webviewOpen('https://events.xiaopeng.com/v596du.html?ch=01549&ps=app');
    } else if (agreedModdeFlag) {
      localStorage.setItem(uid + '_' + 'hasAgreed', 'true');
      setYearlyReportFlag(true);
      setPopupModel(false);
      setAgreedFlag(true);
    } else {
      // 关闭h5
      closeWindow();
    }
  };

  const captureImage = (node: HTMLElement): Promise<string> => {
    return new Promise((resolve, reject) => {
      console.log('captureImage start');
      let finish = false;
      // setTimeout(() => {
      //   if (finish) {
      //     return;
      //   }
      //   finish = true;
      //   console.log('captureImage domtoimage');
      //   domtoimage
      //     .toPng(node)
      //     .then(base64Url => {
      //       console.log(`captureImage domtoimage ${base64Url.length}`);
      //       resolve(base64Url);
      //     })
      //     .catch(e => {
      //       reject(e);
      //     });
      // }, 1000);
      setTimeout(() => {
        html2canvas(node, {
          scale: 1, //缩放比例,默认为1
          allowTaint: false, //是否允许跨域图像污染画布
          useCORS: true, //是否尝试使用CORS从服务器加载图像
          windowWidth: 554, //画布的宽度
          windowHeight: 953 //画布的高度
          // backgroundColor: '#000000' //画布的背景色，默认为透明
        })
          .then(canvas => {
            if (finish) {
              return;
            }
            finish = true;
            //将canvas转为base64格式
            const base64Url = canvas.toDataURL('image/png');
            console.log(`captureImage html2canvas ${base64Url.length}`);
            resolve(base64Url);
          })
          .catch(e => {
            if (finish) {
              return;
            }
            finish = true;
            reject(e);
          });
      }, 500);
    });
  };

  // 生成海报
  useEffect(() => {
    if (document.querySelector('.' + postStyle.posterBox)) {
      // console.log(postStyle.posterBox);
      console.log(document.querySelector('.' + postStyle.posterBox));
      // console.log(document.querySelector('.' + postStyle.audioWhiteView));
      const node = document.querySelector(
        '.' + postStyle.posterBox
      ) as HTMLElement;

      captureImage(node)
        .then(base64Url => {
          let base64UrlSplit = base64Url.split(',')[1];
          console.log(base64Url);
          console.log('base64UrlSplit');
          console.log(base64UrlSplit);
          setcaptureImgSrc(base64UrlSplit);
          // 埋点-海报生成成功
          reportUserBehavior({
            appid: 'N005',
            so: 'N005001',
            ch: '4_0+',
            ut: '',
            mcode: 'summary_page_set_poster_success_uid_' + uid,
            pa: 'summary_page_set_poster_success_uid_' + uid
          });
        })
        .catch(e => {
          console.log(e);
          console.log('生成海报出错');
        });
    }
  }, [posterData]);

  const setPosterFun = () => {
    // 埋点-点击生成你的充电等级
    reportUserBehavior({
      appid: 'N005',
      so: 'N005001',
      ch: '4_0+',
      ut: '',
      mcode: 'summary_page_click_poster_uid_' + uid,
      pa: 'summary_page_click_poster_uid_' + uid
    });
    bridge
      .callHandler('sharePanel', {
        style: 4,
        data: {
          title: '',
          content: '',
          postImage: captureImgSrc,
          shareType: 2,
          url: ''
        },
        addUserInfo: false,
        addExtInfo: false
      })
      .then(res => {
        setLoading(false);
        console.log(res);
        // 埋点-触发分享模块
        reportUserBehavior({
          appid: 'N005',
          so: 'N005001',
          ch: '4_0+',
          ut: '',
          mcode: 'summary_page_share_panel_uid_' + uid,
          pa: 'summary_page_share_panel_uid_' + uid
        });
        // 埋点-点击的分享渠道
        reportUserBehavior({
          appid: 'N005',
          so: 'N005001',
          ch: '4_0+',
          ut: '',
          mcode: 'summary_page_share_type_uid_' + res.data.title,
          pa: 'summary_page_share_type_uid_' + res.data.title
        });
      })
      .catch(e => {
        setLoading(false);
        console.log(e);
      });
  };

  const setAudioStatus = () => {
    if (audioRef && audioRef.current && audioFlag) {
      // 增加回调来获取 onPlay 和 onPasue 的状态，记录一个 playing 的 flag，播放中，则调动 pause()
      // 参考源代码中增加 event 的方式 https://github.com/justinmc/react-audio-player/blob/master/src/index.tsx
      setAudioFlag(false);
      audioRef.current.pause();
      // audioRef.current.play();
    } else if (audioRef && audioRef.current && !audioFlag) {
      setAudioFlag(true);
      audioRef.current.play();
    }
  };

  // const shareWayFun = (type: number) => {
  //   console.log(type);
  //   // setLoading(true);
  //   bridge
  //     // .callHandler('share', {
  //     //   bizType: 'charge',
  //     //   shareType: 2,
  //     //   platform: type,
  //     //   title: '年度充电回顾',
  //     //   content: '我的年度充电回顾',
  //     //   url: '',
  //     //   // thumImageUrl: captureImgSrc,
  //     //   // data.image || (data.icon && encodeURIComponent(data.icon)),
  //     //   // imageData: data.imageData
  //     //   imageData: captureImgSrc || '../../assets/yearly-report/home-group.png'
  //     // })
  //     .callHandler('sharePanel', {
  //       style: 4,
  //       data: {
  //         title: '分享',
  //         content: '',
  //         thumImageUrl:
  //           captureImgSrc || '../../assets/yearly-report/home-group.png',
  //         postImageUrl:
  //           captureImgSrc || '../../assets/yearly-report/home-group.png',
  //         shareType: 2,
  //         url: ''
  //       }
  //     })
  //     .then(res => {
  //       setLoading(false);
  //       console.log(res);
  //       if (res.code !== 1) {
  //         console.log('分享成功');
  //         // Toast.error(res.msg);
  //         // 埋点-点击的分享渠道
  //         reportUserBehavior({
  //           appid: 'N005',
  //           so: 'N005001',
  //           ch: '4_0+',
  //           ut: '',
  //           mcode: 'summary_page_share_type_uid_' + res.data.title,
  //           pa: 'summary_page_share_type_uid_' + res.data.title
  //         });
  //       } else {
  //         Toast.show('请先安装对应APP');
  //         console.log('分享失败');
  //       }
  //     })
  //     .catch(e => {
  //       console.log(e);
  //     });
  // };

  const showAgreedModel = type => {
    if (!uid) {
      Confirm.open('请先登录', {
        type: 2,
        confirmText: '确定',
        header: '',
        confirmCbk: (destroy): void => {
          destroy();
          // 关闭h5
          closeWindow();
        }
      });
      return;
    }
    let agreedStorage = localStorage.getItem(uid + '_' + 'hasAgreed');
    console.log('存储的data');
    console.log(uid + '_' + 'hasAgreed' + agreedStorage);
    if (!agreedStorage) {
      agreedModdeStatus(true);
      setPopupModel(true);
      setPopupModelType(2);
      setPopuModelTitle('隐私声明');
      setPopuModelContent(
        '    请您仔细阅读如下个人信息保护指引，并在充分理解、认可后，开始使用我们的服务：\n    为向您提供专属于您的2021年年度充电报告，我们需要收集您登录小鹏账号的UID、昵称和头像信息、您的小鹏汽车VIN码、车牌号、车辆照片，您驾驶小鹏汽车的车龄、里程、充电次数、充电时间、充电所在城市和充电场站信息、充电SOC数据、年累计充电度数、年累计充电次数，并统计您的行驶里程、充电SOC数据在所有车主中的百分比等数据。\n    该等数据仅作为制作2021年度充电报告的依据，不做其他用途。本服务仅在征得您的授权同意后，我们才会收集对应的信息。您阅读并确认后，视为您对我司就上述信息进行完整的授权。\n'
      );
      setCopyrightContent(
        '本报告背景音乐： Chained Story 许可:CC-BY 作者:SOUNDORBIS 来源:耳聆网'
      );
      setCopyrightFlag(true);
      setConfirmText('同意');
      setCancelText('不同意');
      setBtnSeconds(3000);
      setCloseWindowFlag(false);
      // 埋点-点击协议
      reportUserBehavior({
        appid: 'N005',
        so: 'N005001',
        ch: '4_0+',
        ut: '',
        mcode: 'summary_page_open_agreement_uid_' + uid,
        pa: 'summary_page_open_agreement_uid_' + uid
      });
    } else if (agreedStorage && type === 1) {
      agreedModdeStatus(true);
      setPopupModel(true);
      setPopupModelType(1);
      setPopuModelTitle('隐私声明');
      setPopuModelContent(
        '    请您仔细阅读如下个人信息保护指引，并在充分理解、认可后，开始使用我们的服务：\n    为向您提供专属于您的2021年年度充电报告，我们需要收集您登录小鹏账号的UID、昵称和头像信息、您的小鹏汽车VIN码、车牌号、车辆照片，您驾驶小鹏汽车的车龄、里程、充电次数、充电时间、充电所在城市和充电场站信息、充电SOC数据、年累计充电度数、年累计充电次数，并统计您的行驶里程、充电SOC数据在所有车主中的百分比等数据。\n    该等数据仅作为制作2021年度充电报告的依据，不做其他用途。本服务仅在征得您的授权同意后，我们才会收集对应的信息。您阅读并确认后，视为您对我司就上述信息进行完整的授权。\n'
      );
      setCopyrightContent(
        '本报告背景音乐： Chained Story 许可:CC-BY 作者:SOUNDORBIS 来源:耳聆网'
      );
      setCopyrightFlag(true);
      setCancelText('确定');
      setCloseWindowFlag(false);
    } else {
      // 点击进入年度充电回顾报告
      reportUserBehavior({
        appid: 'N005',
        so: 'N005001',
        ch: '4_0+',
        ut: '',
        mcode: 'summary_page_enter_uid_' + uid,
        pa: 'summary_page_enter_uid_' + uid
      });
      setYearlyReportFlag(true);
      setAgreedFlag(true);
    }
  };

  const setNextStatus = status => {
    setNextStatusFun(status);
  };

  const setWhiteIcon = type => {
    setWhiteIconFlag(type);
  };

  return {
    loading,
    yearlyData,
    interTips,
    uid,
    showPopupModel,
    popuModelTitle,
    popuModelContent,
    copyrightContent,
    confirmText,
    cancelText,
    isXpOwner,
    popupModelType,
    showInstructionModel,
    cancelCb,
    confirmFun,
    setPosterFun,
    // shareWayFun,
    shareModel,
    posterData,
    closeShareModel,
    swiperController,
    setSwiperFun,
    yearlyReportFlag,
    setYearlyReportFlag,
    agreedFlag,
    setAgreedFlag,
    showAgreedModel,
    audioRef,
    setAudioStatus,
    audioFlag,
    setNextStatus,
    nextStatus,
    btnSeconds,
    copyrightFlag,
    setWhiteIcon,
    whiteIconFlag
  };
}
